// views/AppShell.jsx
//
// Persistent shell for the top-level app routes that each used to render their
// own <Sidebar> (Zeno at "/" and Home at "/home"). Mounting the rail here — once —
// keeps it alive when navigating between those routes, so the sidebar (and the
// profile photo) no longer reload on every switch. Only the <Outlet> content swaps.
//
// El mapeo destino ↔ ruta ya no vive aquí: está en lib/navigation.js, que es la
// misma tabla que consumen el Sidebar y el command palette.
//
// En móvil el rail no cabe: 80px plegado se come un quinto de la pantalla y aun
// así sólo muestra iconos. Debajo de `md` se oculta y su trabajo lo reparten la
// barra de abajo (los cinco destinos de siempre) y un cajón (todo lo demás).
// Los dos navegan por el mismo `onSelect`, así que hay una sola tabla de
// destinos y un solo resaltado para las tres superficies.
import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import MobileNav from "../components/Sidebar/MobileNav";
import { MobileNavProvider } from "../components/Sidebar/MobileNavContext";
import { destinationIdForLocation, pathForDestination } from "../lib/navigation";

export default function AppShell() {
  const navigate = useNavigate();
  const location = useLocation();

  const active = destinationIdForLocation(location.pathname, location.search);

  const handleSidebarSelect = (id) => {
    const path = pathForDestination(id);
    if (path) navigate(path);
  };

  return (
    <MobileNavProvider>
      <Sidebar active={active} onSelect={handleSidebarSelect} />
      <MobileNav active={active} onSelect={handleSidebarSelect} />
      <Outlet />
    </MobileNavProvider>
  );
}
